/* TODO: in the future, might want to improve the typing for this esp for the param being passed */
import type {RepairData} from '../features/api/types';

export const cleanRepairData = (repair: Record<string, unknown>): RepairData | null => {
  // Values come from HQ:
  // - app/views/claims/_repair_tracking.json.jbuilder
  if (!repair.id) return null;

  return {
    ...repair,
    address: repair.displayAddress as string,
    isPending: !repair.scheduledWindowStart,
    preciseTimes: repair.customerPreciseTime as boolean,
    repairState: repair.state as string,
    selectedStore: {storeId: repair.storeLookupCode as string | null},
    utcOffset: (repair.timeOffset as number) * 60,
  } as RepairData;
};
